// custom code start
(function () {
  var Tracking = window.Tracking || {};
  window.Tracking = Tracking;

  Tracking.userId = Tracking.userId || null;
  Tracking.productCache = Tracking.productCache || {};
  Tracking.categoryMap = Tracking.categoryMap || {};
  Tracking.init = Tracking.init || {};

  // Restore productCache from sessionStorage so items added on previous pages
  // (different collection, PDP, etc.) still have category data when drawer opens
  try {
    var storedCache = sessionStorage.getItem('tracking:productCache');
    if (storedCache) {
      var parsedCache = JSON.parse(storedCache);
      if (parsedCache && typeof parsedCache === 'object') {
        Object.keys(parsedCache).forEach(function (k) {
          if (!Tracking.productCache[k]) Tracking.productCache[k] = parsedCache[k];
        });
      }
    }
  } catch (e) {}

  window.dataLayer = window.dataLayer || [];

  Tracking.applyCategoryFromHandle = function (item, handle) {
    if (!item || !handle) return;
    var entry = Tracking.categoryMap[handle];
    if (!entry) return;
    item.item_category = entry[0] || '';
    item.item_category2 = entry[1] || '';
    item.item_category3 = entry[2] || '';
  };

  Tracking.applyCategoryFromListId = function (item, listId) {
    if (!item || !listId || typeof listId !== 'string') return;
    var prefix = 'collection_';
    if (listId.indexOf(prefix) !== 0) return;
    Tracking.applyCategoryFromHandle(item, listId.slice(prefix.length));
  };

  Tracking.push = function (payload) {
    if (!payload || !payload.event) return;

    if (payload.event === 'user_data' && payload.user_id) {
      Tracking.userId = payload.user_id;
    }

    if (payload.ecommerce && Array.isArray(payload.ecommerce.items)) {
      payload.ecommerce.items.forEach(function (item) {
        if (item && item.item_list_id) {
          Tracking.applyCategoryFromListId(item, item.item_list_id);
        }
      });
      cacheItems(payload.ecommerce.items);
      // GA4 best practice: reset ecommerce before every ecommerce event
      // Prevents items[] from previous events merging into the current one
      window.dataLayer.push({ ecommerce: null });
    }

    window.dataLayer.push(payload);
  };

  function cacheItems(items) {
    if (!Array.isArray(items)) return;
    var changed = false;
    items.forEach(function (item) {
      if (!item || !item.url) return;
      var match = item.url.match(/\/products\/([^/?#]+)/);
      if (match) {
        Tracking.productCache[match[1]] = item;
        changed = true;
      }
    });
    if (changed) {
      try {
        sessionStorage.setItem('tracking:productCache', JSON.stringify(Tracking.productCache));
      } catch (e) {}
    }
  }

  var mapNode = document.getElementById('datalayer-category-map');
  if (mapNode && mapNode.textContent) {
    try {
      Tracking.categoryMap = JSON.parse(mapNode.textContent) || {};
    } catch (e) {
      if (window.console) {
        console.warn('[Tracking] category map parse error:', e);
      }
    }
  }

  var islands = document.querySelectorAll(
    'script[type="application/json"][id^="datalayer-"]'
  );

  for (var i = 0; i < islands.length; i++) {
    if (islands[i].id === 'datalayer-category-map') continue;
    var raw = islands[i].textContent;
    if (!raw) continue;
    try {
      Tracking.push(JSON.parse(raw));
    } catch (e) {
      if (window.console) {
        console.warn('[Tracking] island parse error:', islands[i].id, e);
      }
    }
  }
})();
// custom code end